import { render, staticRenderFns } from "./ImageSettings.vue?vue&type=template&id=3c25632a&scoped=true"
import script from "./ImageSettings.vue?vue&type=script&lang=js"
export * from "./ImageSettings.vue?vue&type=script&lang=js"
import style0 from "./ImageSettings.vue?vue&type=style&index=0&id=3c25632a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c25632a",
  null
  
)

export default component.exports